var _style, _path, _path2, _rect, _polygon, _polygon2, _path3, _path4, _path5, _path6, _rect2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBulldozer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00AF57;}\n\t.st1{fill:#1E1E1E;}\n\t.st2{fill:#231F20;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 8.2,
    transform: "matrix(0.7078 -0.7064 0.7064 0.7078 -4.8323 8.1362)",
    style: {
      fill: "#000"
    },
    width: 0.3,
    height: 3.3
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6,10.8l-0.3,0.3l0.8,0.8l0,0c0,0,0.1,0,0.1,0c0.1,0,0.2-0.1,0.2-0.2c0,0,0-0.1,0-0.1l0,0L8.6,10.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 9.9,
    transform: "matrix(0.7078 -0.7064 0.7064 0.7078 -6.056 5.4597)",
    style: {
      fill: "#000"
    },
    width: 3.3,
    height: 0.3
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,8.9l0.3,0.3l0.8-0.8l0,0c0,0,0-0.1,0-0.1C5.6,8.1,5.5,8,5.5,8c0,0-0.1,0-0.1,0l0,0L4.5,8.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M7.7,12.4c0.2,0.2,0.6,0.2,0.9,0c0.2-0.2,0.2-0.6,0-0.9L5.9,8.9L5.1,9.8L7.7,12.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M6.5,9.4c0.2-0.2,0.2-0.6,0-0.9c-0.2-0.2-0.6-0.2-0.9,0L3,11.1L3.9,12L6.5,9.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 13.6,
    width: 0.6,
    height: 2.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "14.9,11.1 14.9,12.9 9.4,11.9 10.6,9.2 14.1,9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "15,11 14.2,8.8 13.9,8.9 14.6,10.9 11.7,10.9 11.7,9 11.4,9 11.4,12.2 11.7,12.2 11.7,11.2  14.7,11.2 14.7,12.2 15,12.2 15,11  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.4,
    y: 10.2,
    transform: "matrix(0.3533 -0.9355 0.9355 0.3533 -3.233 16.0842)",
    style: {
      fill: "#000"
    },
    width: 3.2,
    height: 0.3
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "17.2,14.2 7.9,14.2 7.9,12.2 15,12.2 15,11.7 17.2,11.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M10.4,15.6C9.6,15.6,9,15,9,14.3c0-0.7,0.6-1.4,1.4-1.4c0.7,0,1.4,0.6,1.4,1.4C11.7,15,11.1,15.6,10.4,15.6z "
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4,13.2c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1c-0.5,0-1-0.4-1-1C9.4,13.7,9.9,13.2,10.4,13.2L10.4,13.2z  M10.4,12.5c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C12.1,13.2,11.3,12.5,10.4,12.5L10.4,12.5z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7,14.2c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4S10.7,14,10.7,14.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17.2,15.6c-0.7,0-1.4-0.6-1.4-1.4c0-0.7,0.6-1.4,1.4-1.4c0.7,0,1.4,0.6,1.4,1.4C18.6,15,18,15.6,17.2,15.6z "
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,13.2c0.5,0,1,0.4,1,1c0,0.5-0.4,1-1,1s-1-0.4-1-1C16.2,13.7,16.7,13.2,17.2,13.2L17.2,13.2z  M17.2,12.5c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C19,13.2,18.2,12.5,17.2,12.5L17.2,12.5z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6,14.2c0,0.2-0.2,0.4-0.4,0.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4S17.6,14,17.6,14.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M11,9.2h-0.4H10c0-0.3,0.2-0.5,0.5-0.5h3.6c0.3,0,0.5,0.2,0.5,0.5H14h-0.3H11z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M12.3,12.2c0,0.3-0.2,0.5-0.5,0.5H8.9c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-0.3,0.2-0.5,0.5-0.5h2.9 C12.1,11.7,12.3,11.9,12.3,12.2L12.3,12.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 11.6,
    style: {
      fill: "#000"
    },
    width: 2.5,
    height: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 12.2,
    style: {
      fill: "#000"
    },
    width: 2.3,
    height: 2.6
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12.5,
    width: 1.3,
    height: 0.4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 14.7,
    y: 11.6,
    style: {
      fill: "#000"
    },
    width: 0.3,
    height: 0.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M15.5,11.5c-0.1,0.1-0.1,0.4,0,0.5c0.1,0.1,0.4,0.1,0.5,0l1.4-1.4l-0.7-0.4L15.5,11.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 10.8,
    transform: "matrix(0.7076 -0.7066 0.7066 0.7076 -2.5267 15.6963)",
    style: {
      fill: "#000"
    },
    width: 1.6,
    height: 0.3
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4,11.4l-0.3-0.3L16.3,12l0,0c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.2,0.2c0,0,0.1,0,0.1,0l0,0L17.4,11.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 17.9,
    y: 9.5,
    style: {
      fill: "#000"
    },
    width: 1.6,
    height: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2,9.8V9.4h-1.1l0,0c0,0-0.1,0-0.1,0c-0.1,0.1-0.1,0.2,0,0.3c0,0,0.1,0,0.1,0l0,0L18.2,9.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M17,10.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.8v-0.7L17,10.1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17,9.3c-0.1,0-0.2,0.1-0.2,0.2v0.9c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2V9.5 C17.2,9.4,17.1,9.3,17,9.3z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2,8c-0.1,0.1-0.1,0.2,0,0.3L6,9c0.1,0.1,0.2,0.1,0.3,0s0.1-0.2,0-0.3L5.5,8C5.4,7.9,5.3,7.9,5.2,8z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16,11.8c0,0.1-0.1,0.2-0.2,0.2s-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2S16,11.7,16,11.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3,8.9c0,0.1-0.1,0.2-0.2,0.2C6,9.1,5.9,9,5.9,8.9c0-0.1,0.1-0.2,0.2-0.2C6.2,8.7,6.3,8.8,6.3,8.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,10.5c0,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2C17.2,10.3,17.2,10.4,17.2,10.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.8,9.2c0,0,0.4,0.8,0.7,1.2c0.4,0.5,0.8,1.1,1.5,1.1V9.2L18.8,9.2L18.8,9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,9.2v2.3c0.6,0,1.1-0.6,1.4-1.1c0.2-0.4,0.7-1.3,0.7-1.3L20.9,9.2L20.9,9.2z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 11.8,
    style: {
      fill: "#000"
    },
    width: 0.9,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.3,
    y: 15.7,
    style: {
      fill: "#000"
    },
    width: 0.9,
    height: 0.3
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7,11.6c-0.8-0.8-2.2-0.8-3,0l1.5,1.5L4.7,11.6z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.1,13.1l-1.5-1.5c-0.8,0.8-0.8,2.2,0,3l0,0c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1l-0.3-0.3L3.1,13.1z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulldozer);
export default __webpack_public_path__ + "static/media/bulldozer.7a36073607aeedab93e740741f87fba5.svg";
export { ForwardRef as ReactComponent };